export enum FetchResult {
  OK = 'ok',
  FAILED = 'failed',
  STALE = 'stale',
}
